import { Component, Input, OnInit } from '@angular/core';
import { FitMedProfile } from '@models/data/fit-med-profile/FitMedProfile';
import { ClinicianDashboardRoutes } from '@shared/common/routing/clinician-dashboard-routes';
import { AppAuthService } from '@services/core/auth/app-auth.service';
import {hasValue} from '@shared/utils/helpers';
import { Router, RouterLink } from "@angular/router";
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { GenderComponent } from '../../../../components/gender/gender.component';
import { ProfilePictureWithAlertsComponent } from '../../../../components/profile-picture/profile-picture-with-alerts/profile-picture-with-alerts.component';
import { ProfilePictureComponent } from '../../../../components/profile-picture/profile-picture.component';


@Component({
    selector: 'app-ed-fit-med-profile-small',
    templateUrl: './ed-fit-med-profile-small.component.html',
    styleUrls: ['./ed-fit-med-profile-small.component.scss'],
    standalone: true,
    imports: [ProfilePictureComponent, ProfilePictureWithAlertsComponent, RouterLink, GenderComponent, LocalizedDatePipe]
})
export class EdFitMedProfileSmallComponent implements OnInit {
  darkModeBgColour = 'dark:bg-gray-950'

  @Input() set transparentBg(c: boolean) {
    if (c) {
      this.darkModeBgColour = 'bg-transparent'
    }
  }

  // if you need the background of fitmedprofile small to be lighter in some circumstances set this to true
  @Input() set lighterAccent(c: boolean) {
    if (c) {
      this.darkModeBgColour = 'dark:bg-gray-850'
    }
  }

  @Input() set nameLinkSubject(content: 'PATIENTS' | 'CLINICIANS') {
    this.nameLink = ClinicianDashboardRoutes[content].view.fullUrl;
  }

  // Inputting profile picture components
  @Input() profilePicWithAlerts = false;
  @Input() amountOfAlerts: string = null;
  @Input() alertColour = 'red';
  @Input() navigationEnabled = true;

  public fullName = '';
  @Input() practitionerId: string = null;
  public patientFitMedProfileId: string = null;

  fitMedProfileValue: FitMedProfile = null;

  @Input() set fitMedProfile(content: FitMedProfile) {
    if (hasValue(content)) {
      this.fitMedProfileValue = content;
      this.fullName = content ? content?.firstName + ' ' + content?.lastName : '';
      this.patientFitMedProfileId = content.id;
    }
  }

  nameLink = ClinicianDashboardRoutes.PATIENTS.view.fullUrl;

  // If other information needs to be inputted instead of whats currently displayed
  @Input() title: string = null;
  @Input() subtitle: string = null;

  // dictates whether to navigate if the user clicks anywhere on the profile
  @Input() navigateClickAnywhere = false;

  constructor(private appAuthService: AppAuthService, private router: Router) {
  }

  navigateIfFullClick(): void {
    if (this.navigateClickAnywhere) {
      const patientFitMedProfileId = this.patientFitMedProfileId;
      const practitionerId = this.practitionerId;

      this.router.navigate([this.nameLink], { queryParams: { patientFitMedProfileId, practitionerId } }).then(_ => void 0)
    }
  }

  ngOnInit(): void {
    // if (!this.practitionerId) {
    //   this.practitionerId = this.appAuthService.currentUserValue.practitioner.id;
    // }
  }
}
